import { render } from "./FreeStyleChat.vue?vue&type=template&id=b7d75ed2&scoped=true"
import script from "./FreeStyleChat.vue?vue&type=script&lang=js"
export * from "./FreeStyleChat.vue?vue&type=script&lang=js"

import "./FreeStyleChat.vue?vue&type=style&index=0&id=b7d75ed2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b7d75ed2"]])

export default __exports__